import { UseGetTagAttributesReturns } from '@components/Universals/ProductItem/useTagAttributes';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';

import { labelAttributes, supportedCornerAttributes } from './model';
import { transformAttributesToTags } from './utils';

export const useCornerTags = ({
  attributes,
  isColorPicker,
}: {
  attributes: Record<string, unknown>;
  isColorPicker: boolean;
}): null | Omit<UseGetTagAttributesReturns, 'label'> => {
  const { product } = useProductDetailContext();

  if (!attributes) {
    return null;
  }

  const renderableAttributes = transformAttributesToTags(attributes);

  if (renderableAttributes.length === 0) {
    return null;
  }

  const attribute = renderableAttributes[0];

  if (
    product.variants.every((variant) => variant.attributes[attribute]) &&
    isColorPicker
  ) {
    return null;
  }

  if (!supportedCornerAttributes.includes(attribute)) {
    return null;
  }

  return {
    attribute,
    ...labelAttributes[attribute],
  };
};
